import { render } from "./ChoiceQuestionResult.vue?vue&type=template&id=a54837ca"
import script from "./ChoiceQuestionResult.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionResult.vue?vue&type=script&lang=js"

import "./ChoiceQuestionResult.vue?vue&type=style&index=0&id=a54837ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__